module.exports = __webpack_public_path__ + "BrandAssetLibrary_2024_ConsumerBenefit_ProductTower_4x5.9a42504cf64f33710e7aa6b169f298e9.jpg";